var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.499 6.203a3.01 3.01 0 0 0-2.123-2.134C19.504 3.563 12 3.563 12 3.563s-7.504 0-9.376.506A3.02 3.02 0 0 0 .501 6.203C0 8.085 0 12.016 0 12.016s0 3.93.501 5.813a2.97 2.97 0 0 0 2.123 2.102c1.872.506 9.376.506 9.376.506s7.504 0 9.376-.506a2.97 2.97 0 0 0 2.123-2.102C24 15.947 24 12.016 24 12.016s0-3.93-.501-5.813M9.547 15.584V8.448l6.272 3.568z"
  })));
};
export default SvgSocialYoutube;